import { WizardSteps } from 'apps/applicationInstallation/constants/constants'
import actionTypes from 'apps/applicationInstallation/constants/ReduxActionTypes'
import { IActionWithPayload } from 'common/core/interfaces/actions'
import { ApplicationsApi } from 'shared/api/requests/applications'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchApplicationByHash = createAsyncAction(
  'applicationInstallation/fetchApplicationByHash',
  async (hash: string) => {
    const response = await ApplicationsApi.fetchApplicationByHash({
      query: { app_hash: hash },
    })
    return response.data
  },
)

export const setStep = (step: WizardSteps): IActionWithPayload<WizardSteps> => ({
  type: actionTypes.APPLICATION_INSTALL_SET_STEP,
  data: step,
})

export const fetchAccounts = createAsyncAction(
  'applicationInstallation/fetchAccounts',
  async (id: number) => {
    const response = await ApplicationsApi.fetchAccounts({
      query: { app_id: id },
    })
    return response.data
  },
)

export const installApplication = createAsyncAction(
  'applicationInstallation/installApplication',
  async ({
    accountId,
    applicationIdOrHash,
  }: {
    accountId: string
    applicationIdOrHash: string
  }) => {
    const response = await ApplicationsApi.installApplication({
      body: { account_id: accountId, app_hash: applicationIdOrHash },
    })
    return response.data
  },
)
